import {
    CONTRACT_PAYMENTS_HISTORY_STATUS_FAILED,
    CONTRACT_PAYMENTS_HISTORY_STATUS_OK,
    CONTRACT_STATUS_CANCELLED,
    CONTRACT_STATUS_CONCLUDED,
    CONTRACT_STATUS_DRAFT,
    CONTRACT_STATUS_INPROGRESS,
    CONTRACT_STATUS_ONHOLD,
    CONTRACT_STATUS_SUSPENDED
} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";



export const useStatusValuesContract = () => {
    const {t} = useTranslation(['salesmarketing'],{keyPrefix:'contract'});
    const theme = useTheme();
    const getStatusColorContract = (status: string) => {
        switch (status) {
            case CONTRACT_STATUS_DRAFT: return theme.palette.secondary.main;
            case CONTRACT_STATUS_CANCELLED: return theme.palette.accent.transparent;
            case CONTRACT_STATUS_CONCLUDED: return theme.palette.neutral.transparent;
            case CONTRACT_STATUS_INPROGRESS: return theme.palette.success.transparent;
            case CONTRACT_STATUS_ONHOLD: return theme.palette.warning.transparent;
            case CONTRACT_STATUS_SUSPENDED: return theme.palette.neutral.dark;
            case CONTRACT_PAYMENTS_HISTORY_STATUS_FAILED: return theme.palette.error.transparent;
            case CONTRACT_PAYMENTS_HISTORY_STATUS_OK: return theme.palette.success.transparent
        }
    };

    const getStatusLabelContract = (status: string) => {
        switch (status) {
            case CONTRACT_STATUS_DRAFT: return t('statusValues.draft');
            case CONTRACT_STATUS_CANCELLED: return t('statusValues.cancelled');
            case CONTRACT_STATUS_CONCLUDED: return t('statusValues.concluded');
            case CONTRACT_STATUS_INPROGRESS: return t('statusValues.inProgress');
            case CONTRACT_STATUS_ONHOLD: return t('statusValues.onHold');
            case CONTRACT_STATUS_SUSPENDED: return t('statusValues.suspended')
            case CONTRACT_PAYMENTS_HISTORY_STATUS_FAILED: return t('paymentsHistoryTable.paymentsHistoryStatusValues.failed')
            case CONTRACT_PAYMENTS_HISTORY_STATUS_OK: return t('paymentsHistoryTable.paymentsHistoryStatusValues.ok')
            default : return '-'
        }
    };

    return {
        getStatusColorContract,
        getStatusLabelContract
    }
}